/**
 * Helper functions for zooplankton management
 */

/**
 * Add a new sample type
 */
export const addNewSampleTypeHelper = (
  newSampleTypeName,
  sampleTypes,
  setSampleTypes,
  setZooplanktonSampleType,
  setOrganismsBySampleType,
  setNewSampleTypeName,
  setShowAddSampleTypeDialog,
  toast
) => {
  if (!newSampleTypeName.trim()) {
    toast.error('Skriv inn prøvetype');
    return;
  }
  
  if (sampleTypes.includes(newSampleTypeName.trim())) {
    toast.error('Prøvetypen finnes allerede');
    return;
  }
  
  setSampleTypes(prev => [...prev, newSampleTypeName.trim()]);
  setZooplanktonSampleType(newSampleTypeName.trim());
  setOrganismsBySampleType(prev => ({...prev, [newSampleTypeName.trim()]: []}));
  setNewSampleTypeName('');
  setShowAddSampleTypeDialog(false);
  toast.success(`Prøvetype "${newSampleTypeName.trim()}" lagt til`);
};

/**
 * Add a new zooplankton organism
 */
export const addNewZooplanktonOrganismHelper = (
  newZooplanktonOrganismName,
  zooplanktonSampleType,
  organismsBySampleType,
  setOrganismsBySampleType,
  setZooplanktonOrganism,
  setNewZooplanktonOrganismName,
  setShowAddZooplanktonOrganismDialog,
  toast
) => {
  if (!newZooplanktonOrganismName.trim()) {
    toast.error('Skriv inn organismenavn');
    return;
  }
  
  if (!zooplanktonSampleType) {
    toast.error('Velg prøvetype først');
    return;
  }
  
  if (organismsBySampleType[zooplanktonSampleType]?.includes(newZooplanktonOrganismName.trim())) {
    toast.error('Organismen finnes allerede');
    return;
  }
  
  setOrganismsBySampleType(prev => ({
    ...prev,
    [zooplanktonSampleType]: [...(prev[zooplanktonSampleType] || []), newZooplanktonOrganismName.trim()]
  }));
  setZooplanktonOrganism(newZooplanktonOrganismName.trim());
  setNewZooplanktonOrganismName('');
  setShowAddZooplanktonOrganismDialog(false);
  toast.success(`Organisme "${newZooplanktonOrganismName.trim()}" lagt til`);
};

/**
 * Add a zooplankton row to the table
 */
export const addZooplanktonRowHelper = (
  zooplanktonSampleType,
  zooplanktonOrganism,
  zooplanktonOrganisms,
  setZooplanktonOrganisms,
  setZooplanktonSampleType,
  setZooplanktonOrganism,
  setShowZooplanktonForm,
  toast
) => {
  if (!zooplanktonSampleType.trim() || !zooplanktonOrganism.trim()) {
    toast.error('Vennligst fyll inn både prøvetype og organisme');
    return;
  }
  
  // Check if organism already exists
  const exists = zooplanktonOrganisms.some(
    org => org.sampleType === zooplanktonSampleType && org.organism === zooplanktonOrganism
  );
  
  if (exists) {
    toast.error('Denne zooplankton-organismen finnes allerede');
    return;
  }
  
  // Add new zooplankton organism
  const newOrganism = {
    sampleType: zooplanktonSampleType,
    organism: zooplanktonOrganism,
    isCustom: true
  };
  
  setZooplanktonOrganisms(prev => [...prev, newOrganism]);
  
  // Reset form
  setZooplanktonSampleType('');
  setZooplanktonOrganism('');
  setShowZooplanktonForm(false);
  
  toast.success('Ny zooplankton-rad lagt til');
};

/**
 * Insert a new zooplankton row after a specific index
 */
export const insertZooplanktonRowAfterHelper = (
  index,
  setShowZooplanktonForm
) => {
  // This just opens the form; the actual insertion logic is handled by addZooplanktonRowHelper
  setShowZooplanktonForm(true);
};
